module.exports = __webpack_public_path__ + "img/bg.90679d87.png";